import React from "react";

const LogoBG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="365.058"
      height="437.376"
      viewBox="0 0 365.058 437.376"
    >
      <g
        id="Group_6371"
        data-name="Group 6371"
        transform="translate(-303.942 -169.624)"
      >
        <g
          id="Group_67"
          data-name="Group 67"
          transform="translate(-22.286 -28)"
        >
          <path
            id="Path_171"
            data-name="Path 171"
            d="M320.911,294.812s4.555-18.453,16.588-25.552"
            transform="translate(5.802 5.188)"
            fill="none"
            stroke="#5e5e5e"
            strokeWidth="1"
          />
          <g
            id="Ellipse_2"
            data-name="Ellipse 2"
            transform="translate(342 269)"
            fill="none"
            stroke="#5e5e5e"
            strokeWidth="1"
          >
            <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
            <circle cx="3.5" cy="3.5" r="3" fill="none" />
          </g>
        </g>
        <g
          id="Group_68"
          data-name="Group 68"
          transform="matrix(0.105, -0.995, 0.995, 0.105, 38.036, 802.97)"
        >
          <path
            id="Path_171-2"
            data-name="Path 171"
            d="M320.911,294.812s4.555-18.453,16.588-25.552"
            transform="translate(5.802 5.188)"
            fill="none"
            stroke="#5e5e5e"
            strokeWidth="1"
          />
          <g
            id="Ellipse_2-2"
            data-name="Ellipse 2"
            transform="translate(342 269)"
            fill="none"
            stroke="#5e5e5e"
            strokeWidth="1"
          >
            <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
            <circle cx="3.5" cy="3.5" r="3" fill="none" />
          </g>
        </g>
        <g
          id="Ellipse_5"
          data-name="Ellipse 5"
          transform="translate(497 497)"
          fill="none"
          stroke="#5e5e5e"
          strokeWidth="1"
        >
          <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
          <circle cx="3.5" cy="3.5" r="3" fill="none" />
        </g>
        <text
          id="_"
          data-name="*"
          transform="translate(514 260)"
          fill="#6d6d6d"
          fontSize="18"
          fontFamily="Roboto-Regular, Roboto"
        >
          <tspan x="0" y="0">
            *
          </tspan>
        </text>
        <text
          id="_2"
          data-name="*"
          transform="translate(476 602)"
          fill="#6d6d6d"
          fontSize="18"
          fontFamily="Roboto-Regular, Roboto"
        >
          <tspan x="0" y="0">
            *
          </tspan>
        </text>
        <text
          id="_3"
          data-name="+"
          transform="translate(443.819 191.575) rotate(-31)"
          fill="#6d6d6d"
          fontSize="18"
          fontFamily="Roboto-Regular, Roboto"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
        <text
          id="_4"
          data-name="+"
          transform="translate(650.853 551.714) rotate(-31)"
          fill="#6d6d6d"
          fontSize="18"
          fontFamily="Roboto-Regular, Roboto"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
        <circle
          id="Ellipse_4"
          data-name="Ellipse 4"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(662 346)"
          fill="#6d6d6d"
        />
        <circle
          id="Ellipse_6"
          data-name="Ellipse 6"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(320 595)"
          fill="#6d6d6d"
        />
        <g
          id="Ellipse_416"
          data-name="Ellipse 416"
          transform="translate(597 177)"
          fill="none"
          stroke="#5e5e5e"
          strokeWidth="1"
        >
          <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
          <circle cx="3.5" cy="3.5" r="3" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default LogoBG;
